import React from 'react'
import { makeStyles, createStyles, createTheme } from '@material-ui/core/styles';
import DefaultModal, { DefaultModalContent } from '../../../../Components/DefaultModal';
import {  ViewTextEditor } from '../../../../Components/Editor';
import themes from '../../../../theme';

const useStyles = makeStyles((theme) =>
createStyles({
  root:{
    margin: 0,
    padding: 0,
    
  },
  main: {
    padding: "0rem 0.5rem 1rem 0.5rem",
    margin:  "0px",
    [theme.breakpoints.up("xs")]: { minWidth: 380, maxWidth: 380 },
    [theme.breakpoints.up("sm")]: { minWidth: 380, maxWidth: 400 },
    [theme.breakpoints.up("md")]: { minWidth: 380, maxWidth: 450 },  
    [theme.breakpoints.up("lg")]: { minWidth: 380, maxWidth: 500 },
    [theme.breakpoints.up("xl")]: { minWidth: 380, maxWidth: 550 },
  },
  speedDial:{
    //marginLeft:"-1.5rem",
    transform: 'scale(0.825)',
  }
})
);

const ViewTheme = createTheme({...themes,
  overrides: {
    MUIRichTextEditor: {
      editor: {
        margin: 0,
        paddingRight:"1rem",
        paddingLeft: "1rem",
        minHeight: "200px",
        //maxHeight: "350px",
        overflow: "auto"
      },
    },
  },
});
 
export const ModalHelp = ({open, close}) => {
  const classes = useStyles();
  const text =`<h2> Matriz de Prioridade GUT:  gravidade, urgência e tendência</h2><p>A Matriz de Prioridade GUT analisa três fatores básicos de qualquer problema, e procura quantificar numericamente que problemas são mais graves. Por meio dela, é possível apontar de forma concreta, com uma escala numérica, quais problemas são mais prejudiciais a empresa. Assim é possível priorizar melhor as atividades.</p><p>Por se tratar de uma ferramenta simples, <strong>a Matriz de Prioridade GUT pode ser utilizada em qualquer contexto e por qualquer pessoa</strong>. É importante que quem for aplicá-la conheça bem o processo, pois poderá avaliar melhor o problema.</p><h2>Como funciona a ferramenta</h2><p>A Matriz de Prioridade GUT analisa três aspectos: gravidade, urgência, tendência. Para cada aspecto analisado, deve-se dar <strong>uma nota que varia de 1 a 5</strong>, de acordo com o aspecto analisado. Vejamos melhor o que cada aspecto avalia:</p><h3>Gravidade</h3><p>Avalia o grau de impacto que o problema pode causar. Pode-se avaliar, por exemplo: se haverá prejuízos; se a produção será parada; se o cliente será prejudicado; etc. Aqui, quanto mais grave o problema, maior será a nota atribuída.</p><h3>Urgência</h3><p>Na Urgência, devemos avaliar o quão rápido esse problema precisa ser resolvido. Aqui, podemos falar, por exemplo, sobre problemas que tem prazos específicos para serem resolvidos. Além disso, também podemos levar em consideração <strong>se o problema está afetando o cliente</strong> e, assim, precisa ser resolvido mais rápido. Quanto menos tempos tivermos para resolver esse problema, maior será a nossa nota.</p><h3>Tendência</h3><p>No último aspecto analisado, temos a tendência. Ela corresponde a quanto o problema pode piorar se não for resolvido.</p><p></p><h3>Multiplique as notas atribuídas</h3><p>Depois que você analisar os problemas, atribuindo notas para Gravidade, Tendência e Urgência, é preciso multiplicar os resultados. Basta fazer <strong>Gravidade x Tendência x Urgência</strong>.</p><p></p><p>Agora temos uma escala que mostra qual problema precisa ser resolvido mais urgentemente. Quanto maior o número alcançado nessa coluna, maior a prioridade de resolução, pois <strong>maiores serão os impactos dele.</strong></p>`;
  return (
    <DefaultModal open={open} handleClose={close} title={"Matriz de Prioridade GUT"} maxWidth="sm">
      <DefaultModalContent dividers className={classes.root}>
      <ViewTextEditor
       isTheme
       customTheme={ViewTheme}
       value={text}
      />
      </DefaultModalContent>
    </DefaultModal>
  )
}

 
